import * as React from 'react';
import bindAllOfThis from "src/utils/BindThisHelper";
import PhaserGameComponent from 'src/games/shared/phaserHelpers/PhaserGameComponent';
import { GameIntroScene } from './scenes/GameIntro';

interface OceanCleanupGameProps {
    onComplete: () => void;
}

interface OceanCleanupGameState {
}

const gameConfig: GameConfig = {
    title: "Ocean Cleanup Game",
    version: "0.2",
    backgroundColor: "#000000",
    physics: {
        default: "arcade",
        arcade: {
            debug: false,
            gravity: { x: 0, y: 0 }
        }
    },
};

class PhaserOceanCleanupGame extends React.Component<OceanCleanupGameProps, OceanCleanupGameState> {
    private game: Phaser.Game;
    constructor(props: OceanCleanupGameProps) {
        super(props);
        bindAllOfThis(this, PhaserOceanCleanupGame.prototype);
    }

    render() {
        return (<div>
            <PhaserGameComponent scenes={GameIntroScene} config={gameConfig} onComplete={this.props.onComplete} />
        </div>);
    }
}

export default PhaserOceanCleanupGame;



// WEBPACK FOOTER //
// ./src/games/OceanCleanupGame/Main.tsx